import React from 'react';
import { RoleCard } from '../atoms/RoleCard';
import { RoleFormModal } from '../molecules/RoleFormModal';
import { Role } from '@/services/rolesPermissionsService';

interface RolesListProps {
  roles: Role[];
  isLoading: boolean;
  searchText: string;
  // Modal states
  isRoleModalOpen: boolean;
  onRoleModalOpenChange: (open: boolean) => void;
  editingRole: Role | null;
  // Actions
  onEditRole: (role: Role) => void;
  onDeleteRole: (roleId: number) => void;
  onManagePermissions: (role: Role) => void;
  onSubmitRole: (e: React.FormEvent<HTMLFormElement>) => void;
  onResetRoleForm: () => void;
  isSubmitting: boolean;
}

export const RolesList: React.FC<RolesListProps> = ({
  roles,
  isLoading,
  searchText,
  isRoleModalOpen,
  onRoleModalOpenChange,
  editingRole,
  onEditRole,
  onDeleteRole,
  onManagePermissions,
  onSubmitRole,
  onResetRoleForm,
  isSubmitting
}) => {
  // Filtrar roles basado en el texto de búsqueda
  const filteredRoles = roles.filter(role => {
    if (!searchText) return true;
    
    const searchLower = searchText.toLowerCase();
    const displayName = (role.display_name || role.name).toLowerCase();
    const description = (role.description || '').toLowerCase();
    const name = role.name.toLowerCase();
    
    return displayName.includes(searchLower) || 
           description.includes(searchLower) || 
           name.includes(searchLower);
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap justify-between items-center gap-2">
        <h2 className="text-xl font-semibold">Roles del Sistema</h2>
        <RoleFormModal
          isOpen={isRoleModalOpen}
          onOpenChange={onRoleModalOpenChange}
          editingRole={editingRole}
          onSubmit={onSubmitRole}
          isLoading={isSubmitting}
          onReset={onResetRoleForm}
        />
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {isLoading ? (
          <div className="col-span-full flex items-center justify-center py-12">
            <div className="flex flex-col items-center gap-3">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <p className="text-muted-foreground">Cargando roles...</p>
            </div>
          </div>
        ) : filteredRoles.length === 0 && searchText ? (
          <div className="col-span-full text-center text-muted-foreground py-8">
            No se encontraron roles que coincidan con la búsqueda "{searchText}"
          </div>
        ) : (
          filteredRoles
            .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
            .map((role) => (
              <RoleCard
                key={role.id}
                role={role}
                onEdit={onEditRole}
                onDelete={onDeleteRole}
                onManagePermissions={onManagePermissions}
              />
            ))
        )}
      </div>
    </div>
  );
};